import { filesSlice, initialState } from './Slice'

export type { FilesState } from './Type'
export { initialState, filesSlice }

export default filesSlice.reducer
